const URL_REGEXP = /^(https?:\/\/(?:www\.|(?!www))[А-Яа-яa-zA-Z0-9][А-Яа-яa-zA-Z0-9-]+[А-Яа-яa-zA-Z0-9]\.[^\s]{2,}|www\.[А-Яа-яa-zA-Z0-9][А-Яа-яa-zA-Z0-9-]+[А-Яа-яa-zA-Z0-9]\.[^\s]{1,}|https?:\/\/(?:www\.|(?!www))[А-Яа-яa-zA-Z0-9]+\.[^\s]{1,}|www\.[А-Яа-яa-zA-Z0-9]+\.[^\s]{1,})$/;

export default URL_REGEXP;